import styled, { css } from 'styled-components';

import { getDefaultBackgroundSecondaryColor } from '@mews-ui/theme';
import { Component, Decision, getComponentToken } from '@optimus-web/local-tokens';

export interface BackdropProps {
    light?: boolean;
}

const getBackdropToken = getComponentToken(Component.Backdrop);

const Backdrop = styled.div.attrs({ 'data-test-backdrop': true })<BackdropProps>`
    position: absolute;
    inset: 0;
    background-color: ${getBackdropToken(Decision.BackgroundColor)};

    ${(props) =>
        props.light &&
        css`
            opacity: 0.4;
            background-color: ${getDefaultBackgroundSecondaryColor(props)};
        `}
`;

export default Backdrop;
